import React, { Component } from "react";
import { observer } from "mobx-react";

import { CopyCode } from "../../common/CopyCode";
import { Heading3 } from "../../common/Heading3";
import { Popup } from "../../common/Popup";
import * as styles from "./ShareCodeCreated.scss";

export interface IShareCodeCreatedProps {
    message: string;
    url?: string;
    onClose: () => void;
}

@observer
export class ShareCodeCreated extends Component<IShareCodeCreatedProps> {
    public render() {
        const { url, onClose, message } = this.props;
        return (
            <Popup
                visible={true}
                onClose={onClose}
                className={styles["share-created"]}
            >
                <Heading3 className={styles.heading}>Share</Heading3>
                <div className={styles.content}>
                    {url && (
                        <>
                            <p>{message}</p>
                            <CopyCode
                                singleLine={true}
                                className={styles.url}
                                value={url}
                            />
                        </>
                    )}
                </div>
            </Popup>
        );
    }
}
